

<p-table #dt [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
    <div class="float-right ui-helper-clearfix" >
      <em class="fa fa-search" style="margin:4px 4px 0 0"></em>
      <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" class="bg-white p-0">
  </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th scope="col" class="text-center headerWidth"  pSortableColumn="workFileDefintionName">Workfile Definition Name
        <p-sortIcon field="workFileDefintionName"></p-sortIcon>
      </th>
      <th scope="col" class="text-center headerWidth"  pSortableColumn="fileName">File Name
        <p-sortIcon field="fileName"></p-sortIcon>
      </th>
      <th scope="col" class="text-center headerWidth"  pSortableColumn="fileFormat">File Format
        <p-sortIcon field="fileFormat"></p-sortIcon>
      </th>
      <th scope="col" class="text-center headerWidth"  pSortableColumn="processName">Process
        <p-sortIcon field="processName"></p-sortIcon>
      </th>
      <th scope="col" class="text-center headerWidth"  pSortableColumn="processStepName">Process Step
        <p-sortIcon field="processStepName"></p-sortIcon>
      </th>
      <th scope="col" class="text-center headerWidth" style="width: 8%;" pSortableColumn="active">Active
        <p-sortIcon field="active"></p-sortIcon></th>
      <th scope="col" class="text-center headerWidth" style="width: 8%;" pSortableColumn="continueWithFileConfig">User Config
        <p-sortIcon field="continueWithFileConfig"></p-sortIcon></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="text-center rowtableWidth wrapword" [ngStyle]="{'display': col.display}" *ngIf="col.field != 'active' && col.field != 'continueWithFileConfig'">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'active'" class="text-center rowtableWidth" style="width: 8%;">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'continueWithFileConfig'" class="text-center rowtableWidth" style="width: 8%;">
          <p-checkbox id="continueWithFileConfig" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="text-left">
      <button type="button" pButton class="h-2rem" icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="Workfile Definition" [(visible)]="displayMasterListDialog" [focusOnShow]="false" [maximizable]="true" showEffect="fade" [modal]="true" [style]="{'width':'1050px'}"  [baseZIndex]="1000"
[contentStyle]="{'max-height':'100vh','height':'70vh'}">
  <p-tabView [activeIndex]="tabIndex" (onChange)="tabChange($event)">
    <p-tabPanel header="File Details" [headerStyleClass]="getCSSClassForPanel(0)">
      <div *ngIf="masterList">
        <div class="form-group m-2">
          <div class="inputDiv">
            <label>Workfile Definition Name</label>
            <div>
              <input pInputText class="form-control" [(ngModel)]="masterList['workFileDefintionName']"
                (change)="masterList['workFileDefintionName']=masterList['workFileDefintionName'].trim()" [disabled]="!masterList?.continueWithFileConfig">
            </div>
          </div>
          <div class="threshold">
              <label>Workfile Name</label>
            <div>
              <label style="word-break:break-word;">Preview : {{fileName}}</label>
            </div>
            <div>
              <label>Constant Substring</label>
              <div>
                <input pInputText class="form-control" [(ngModel)]="masterList['constantSubstring']" (input)="addConstSubstringPreview()"
                    (change)="masterList['constantSubstring']=masterList['constantSubstring'].trim()" [disabled]="!masterList?.continueWithFileConfig">
              </div>
            </div>

            <div class="col flex">
                <div class="col-6">
                  <label>File Format</label>
                  <div>
                    <p-dropdown [options]="fileFormatOptions" [(ngModel)]="selectedFileFormat" placeholder="Select a file format" (onChange)="addConstSubstringPreview()"
                      [style]="{'width':'280px' }" optionLabel="name" [showClear]="true" [disabled]="!masterList?.continueWithFileConfig"></p-dropdown>
                  </div>
                    </div>
                <div class="col-6">
                  <label>Machine Type</label>
                  <div>
                    <p-dropdown [options]="machineTypeOptions" [(ngModel)]="selectedMachineType" placeholder="Select a machine type"
                      [style]="{'width':'280px'}" optionLabel="name" [showClear]="true" [disabled]="!masterList?.continueWithFileConfig || continueWithMachineOptions"></p-dropdown>
                  </div>
                </div>
            </div>
          </div>
          <div class="threshold">
            <label>Process</label>
          <div>
            <label>Name</label>
            <div>
              <p-dropdown [options]="processNameOptions" filter="true" filterBy="label" [(ngModel)]="selectedProcess" placeholder="Select a process name"
                  [style]="{'width':'280px' }" optionLabel="name" [showClear]="true" (onChange)="getProcessStepList()"></p-dropdown>
            </div>
          </div>

          <div>
            <label>Step Name</label>
            <div>
              <p-dropdown [options]="stepNameOptions" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label" [(ngModel)]="selectedProcessStep" placeholder="Select a process step name"
                  [style]="{'width':'280px' }" [showClear]="true" (onChange)="getPlateDetails()"></p-dropdown>
            </div>
          </div>
        </div>
          <div class="threshold flex">
            <div class="col-6">
            <label>Continue with file content configuration</label>
            <div>
              <p-checkbox [(ngModel)]="userConfigFlag"  (onChange)="getPlateDetails()" binary="true"></p-checkbox>
            </div>
            </div>
            <div *ngIf="userConfigFlag" class="col-6 flex">
              <label>File content definition</label>
              <div>
                <p-radioButton value="tubes" label="List Of Libraries (Hamilton)" [(ngModel)]="selectedFileContentDefinition"></p-radioButton>
                <p-radioButton value="plate" label="Plate Layout (DragonFly)" [(ngModel)]="selectedFileContentDefinition"></p-radioButton>
              </div>
            </div>
          </div>
        <div class="inputDiv">
          <label>Active</label>
          <div>
            <p-checkbox [(ngModel)]="masterList['active']" binary="true"></p-checkbox>
          </div>
        </div>


        </div>
      </div>

      <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end">
        <button type="button" pButton icon="pi pi-check"  [disabled]="isSaveDisabled()" (click)="saveMasterList()" *ngIf="!userConfigFlag"
          label="Save" class="h-2rem"></button>
        <button type="button" pButton label="Next" class="h-2rem" (click)="nextTab()" *ngIf="userConfigFlag" [disabled]="isSaveDisabled()"></button>
      </div>
      <div class="ui-dialog-buttonpane ui-helper-clearfix">

      </div>
    </p-tabPanel>
    <p-tabPanel header="File Source Definition" [disabled]="disableSourceTab()" [headerStyleClass]="getCSSClassForPanel(1)">
      <div class="threshold">
          <div>
            <label>Database Sources</label><br>
          </div>
          <fieldset style="border: 1px solid #d6d6d6;">
            <legend style="width: auto;font-size: inherit;margin-left: 10px">&ensp;General&ensp;</legend>
            <div class="col flex flex-wrap">
              <div *ngFor="let source of dataSources" class="col-3" style="width: 24.6667%;">
                <input pInputText class="form-control" [value]="source" [disabled]="true" style="width: 13em; text-align: center; opacity: 1.35;">
              </div>
            </div><br>
          </fieldset>
          <fieldset *ngIf="sourcePlatedataSources?.length > 0" style="border: 1px solid #d6d6d6;margin-top: 17px;">
            <legend style="width: auto;font-size: inherit;margin-left: 10px">&ensp;Source Plate&ensp;</legend>
              <div class="col flex flex-wrap">
                <div *ngFor="let source of sourcePlatedataSources" class="col-3" style="width: 24.6667%;">
                  <input pInputText class="form-control" [value]="source" [disabled]="true" style="width: 13em; text-align: center; opacity: 1.35;">
                </div>
              </div><br>
          </fieldset>
          <fieldset *ngIf="targetPlatedataSources?.length > 0" style="border: 1px solid #d6d6d6;margin-top: 17px;">
            <legend style="width: auto;font-size: inherit;margin-left: 10px">&ensp;Target Plate&ensp;</legend>
            <div class="col flex flex-wrap">
              <div *ngFor="let target of targetPlatedataSources" class="col-3" style="width: 24.6667%;">
                <input pInputText class="form-control" [value]="target" [disabled]="true" style="width: 13em; text-align: center; opacity: 1.35;">
              </div>
            </div><br>
          </fieldset>
      </div>
    <div class="threshold">
        <div>
          <label>Calculations</label><br>
        </div>
        <div class="col">
          <div *ngFor="let cal of calculations" class="col-12 flex">
            <input pInputText class="form-control" [value]="cal" [disabled]="true" style="text-align: center; opacity: 1.35;">
          </div>
        </div><br>
        <div class="col-12 flex pl-0 mt-3" *ngIf="calButtonFlag">
            <div class="col-2" style="padding-left: 0px;width: 19%;">
                <label style="white-space: pre-line;display: inline;">Source Name</label>
                <input pInputText class="form-control" [(ngModel)]="calculationObject['sourceName']" style="text-align: center; width:180px; height: 35px;">
            </div>
            <div  class="col-1" style="width: 55px;padding-right: 0px;">
              <label style="margin-top: 26px;padding-left: 40%;">=</label>
            </div>
            <div  class="col-3" style="padding-left: 0px;">
              <label style="white-space: pre-line;display: inline;">Operator</label><br>
              <p-dropdown [options]="operatorOptions" [(ngModel)]="calculationObject['operator']" placeholder="Operator" [style]="{'width':'190px','height':'59%'}" [showClear]="true" ></p-dropdown>
            </div>
            <div  class="col-3" style="padding-left: 0px;width: 22%;">
              <label style="white-space: pre-line;display: inline;">Operand 1</label><br>
              <p-autoComplete [(ngModel)]="calculationObject['firstOperand']" [suggestions]="operandResult" (onBlur)="calculationObject['firstOperand']=calculationObject['firstOperand'].trim()" (completeMethod)="operandSearch($event)" placeholder="Operand 1" [minLength]="1"></p-autoComplete>
            </div>
            <div  class="col-3" style="padding-left: 4%;">
              <label style="white-space: pre-line;display: inline;">Operand 2</label><br>
              <p-autoComplete [(ngModel)]="calculationObject['secondOperand']" [suggestions]="operandResult" (onBlur)="calculationObject['secondOperand']=calculationObject['secondOperand'].trim()" (completeMethod)="operandSearch($event)" placeholder="Operand 2" [minLength]="1"></p-autoComplete>
            </div><br>
        </div>
        <div *ngIf="errorList.length>0" class="text-danger">
          <ul *ngFor="let item of errorList" style="padding-left: 12px;">
            <span style="display: block;" class="font-weight-bold" [innerHTML]="item.header" >{{item.header}}</span>
            <span style="display: block;padding-left: 16px;" [innerHTML]="item.content" >{{item.content}}</span>
          </ul>
        </div>
        <div class="ui-dialog-buttonpane ui-helper-clearfix" style="margin-top:3em;">
          <button type="button" pButton label="Add" class="h-2rem" (click)="addCalculation()" *ngIf="!calButtonFlag"></button>
          <button type="button" pButton label="Submit" class="h-2rem" [disabled]="isSubmitDisabled()" *ngIf="calButtonFlag" (click)="saveCalculation()"></button>
          <button type="button" pButton label="Cancel" class="h-2rem" (click)="cancelCalculation()" *ngIf="calButtonFlag" style="margin-left: 1%;"></button>
        </div>
    </div>
    <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end mt-3" style="margin-top:3em;">
      <button type="button" pButton label="Save" class="h-2rem" (click)="saveMasterList()" [disabled]="errorList.length>0"></button>
      <button type="button" pButton label="Next" class="h-2rem ml-3" (click)="nextTab()"></button>
    </div>
    </p-tabPanel>
    <p-tabPanel header="File Tab Definition" [disabled]="disableSourceTab()" [headerStyleClass]="getCSSClassForPanel(2)">
      <div class="threshold">
          <label>Include Header</label>
           <p-radioButton name="groupname" class="ml-2" value="yes" label="Yes" [(ngModel)]="selectedHeaderValue"></p-radioButton>
           <p-radioButton name="groupname" class="ml-2" value="no" label="No" [(ngModel)]="selectedHeaderValue"></p-radioButton>
           <label class="ml-8">Reduce to one row per quadrant</label>
           <p-checkbox  class="ml-2" [ngModel]="reduceToOneRow" binary="false" (onChange)="setCheckboxValue( $event)"></p-checkbox>
       <div class="threshold">
        <label>Table Definition</label>
          <p-table [value]="tableDefinitionHeaders" [columns]="columnHeaderForDefinition" responsiveLayout="scroll"
              [style]="{'overflow':'visible', 'word-wrap': 'break-word'}">
            <ng-template pTemplate="header">
              <tr>
                  <th scope="col" style="width:5rem" ></th>
                  <th scope="col" class="text-center" style="width:13rem" *ngIf="selectedHeaderValue =='yes'">Header</th>
                  <th scope="col" class="text-center" style="width:24rem">Source
                    &nbsp;<span class="pi pi-exclamation-circle" pTooltip="Select a defined source or enter a constant value." tooltipPosition="right" tooltipZIndex="100000">
                    </span></th>
                  <th scope="col" class="text-center" style="width: 6em;">Column</th>
                  <th scope="col" *ngIf="tableDefinitionHeaders?.length == 0" style="border: 0px;background: none;">
                    <button type="button" style="width: 20px;" pButton icon="pi pi-plus" (click)="addInitialRow()"></button>
                  </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-workfileDefinition let-index="rowIndex">
              <tr [pReorderableRow]="index">
                <td [pTooltip]="hoverDrag" tooltipPosition="right" tooltipZIndex="100000">
                  <span class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td pEditableColumn *ngIf="selectedHeaderValue =='yes'" class="text-center">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" [(ngModel)]="workfileDefinition.header" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{workfileDefinition.header}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td pEditableColumn class="text-center">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-dropdown [style]="{'width':'320px'}"  [options]="groupedSource" [(ngModel)]="workfileDefinition.source"
                              editable="true" placeholder="Source Definition Name" [group]="true" (onChange)="setCategoryNameintoList(workfileDefinition)" >
                              <ng-template let-group pTemplate="group">
                                <span style="margin-left:.25em" >{{group.label}}</span>
                            </ng-template>
                        </p-dropdown>
                      </ng-template>
                        <ng-template pTemplate="output">
                            {{workfileDefinition.source}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td  style="text-align: center;width: 6em;">
                    {{ getRowOrderIndex(workfileDefinition,index)}}
                </td>
                <td style="border: 0px">
                  <button type="button" *ngIf="workfileDefinition.column > 0" style="width: 20px;" pButton icon="pi pi-minus" (click)="deleteRow(workfileDefinition)"></button>
                   <button type="button" class="ml-1" *ngIf="index == tableDefinitionHeaders?.length -1 && workfileDefinition.header && workfileDefinition.source && selectedHeaderValue =='yes'" style="width: 20px;" pButton icon="pi pi-plus"
                  (click)="addRow(workfileDefinition)"></button>
                  <button type="button" class="ml-1" *ngIf="index == tableDefinitionHeaders?.length -1 && selectedHeaderValue =='no' && workfileDefinition.source" style="width: 20px;" pButton icon="pi pi-plus"
                   (click)="addRow(workfileDefinition)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr >
                <td [attr.colspan]="selectedHeaderValue !='no' ? 4 : 3" class="text-center">
                  No records found
                </td>
              </tr>
            </ng-template>
          </p-table><br />
          <div *ngIf="tableDefinitionHeaders?.length > 0 && listOfFileDefError?.length > 0" class="text-danger">
                <ul *ngFor="let tableRow of listOfFileDefError" style="padding-left: 5px;">
                  <span *ngIf="tableRow.header" class="font-weight-bold" >{{tableRow.header}} <br /></span>
                  <span *ngIf="tableRow.headerError" style="display: block;padding-left: 16px;" [innerHTML]="tableRow.headerError">{{tableRow.headerError}}</span>
                  <span *ngIf="tableRow.sourceError" style="display: block;padding-left: 16px;" [innerHTML]="tableRow.sourceError">{{tableRow.sourceError}}</span>
                </ul>
          </div>
       </div>
      </div>
      <div class="ui-dialog-buttonpane ui-helper-clearfix flex justify-content-end mt-3">
        <button type="button" pButton label="Submit" class="h-2rem" [disabled]="tableDefinitionHeaders?.length == 0 || validationFlag" (click)="saveMasterList()"></button>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Reagents & Volumes Definition" [disabled]="disableReagentsAndVolumesTab()" [headerStyleClass]="getCSSClassForPanel(3)">
      <div *ngIf="masterList" class="col-12">
        <div class="threshold">
          <label>Header</label>
          <div class="ml-5">
            <label>Version</label>
              <input pInputText class="form-control" [(ngModel)]="masterList.plateContentDefinition.version"
                     (change)="masterList.plateContentDefinition.version=masterList.plateContentDefinition.version.trim()">
            <div class="col-12 pl-0">
              <label>Treat As Volumes</label>
              <p-inputSwitch [style]="{'margin-left':'1rem'}" [(ngModel)]="masterList.plateContentDefinition.treatAsVolumes"></p-inputSwitch>
            </div>
            <label>Well Volume</label>
            <div class="col-12 p-0">
              <p-inputNumber [showButtons]="true" size="30" [min]="0" step="0.1" [maxFractionDigits]="3" [(ngModel)]="masterList.plateContentDefinition.wellVolume" ></p-inputNumber >
            </div>
          </div>
        </div>
        <div class="threshold">
          <label>Reagent 1</label>
          <div class="ml-5">
            <label>Name</label>
            <input pInputText class="form-control" [(ngModel)]="reagent1Name"
                   (change)="reagent1Name=reagent1Name.trim()">
            <label>Volume</label>
            <div class="col-12 p-0">
              <p-inputNumber [showButtons]="true" size="30" [min]="0" step="0.1" [maxFractionDigits]="3" [(ngModel)]="reagent1Volume" ></p-inputNumber >
            </div>
          </div>
        </div>
        <div class="threshold">
          <label>Reagent 2</label>
          <div class="ml-5">
            <label>Name</label>
            <input pInputText class="form-control" [(ngModel)]="reagent2Name"
                   (change)="reagent2Name=reagent2Name.trim()">
            <label>Volume</label>
            <div class="col-12 p-0">
              <p-inputNumber [showButtons]="true" size="30" [min]="0" step="0.1" [maxFractionDigits]="3" [(ngModel)]="reagent2Volume" ></p-inputNumber >
            </div>
          </div>
        </div>
        <div class="threshold">
          <label>Reagent 3</label>
          <div class="ml-5">
            <label>Name</label>
            <input pInputText class="form-control" [(ngModel)]="reagent3Name"
                   (change)="reagent3Name=reagent3Name.trim()">
            <label>Volume</label>
            <div class="col-12 p-0">
            <p-inputNumber [showButtons]="true" size="30" [min]="0" step="0.1" [maxFractionDigits]="3" [(ngModel)]="reagent3Volume" ></p-inputNumber >
            </div>
          </div>
        </div>
        <div class="flex justify-content-end mt-3">
          <button type="button" pButton label="Submit" class="h-2rem" [disabled]="disableSubmitForDragonFly()" (click)="saveMasterList()"></button>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</p-dialog>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
